<template>
  <div class="root">
    <p>
      <span>项目名称：</span>{{ detail.projectname }}
    </p>
    <p>
      <span>交易形式：</span>{{ detail.flag == 1 ? '转让' : '' }}
    </p>
    <p>
      <span>区 域：</span>{{ detail.address }}
    </p>
    <p>
      <span>需求年限：</span>{{ detail.outyears }}
    </p>
    <p>
      <span>面积/数量：</span>{{ detail.area }}
    </p>
    <p>
      <span>价 格：</span>{{ detail.listingprice }}
    </p>
    <p>
      <span>联 系 人：</span>{{ detail.linkman }}
    </p>
    <p>
      <span>联系电话：</span>{{ detail.linkphone }}
    </p>
    <p>
      <span>电子邮件：</span>{{ detail.email }}
    </p>
    <p>
      <span>联系地址：</span>{{ detail.address }}
    </p>
    <p>
      <span>项目简况：</span>{{ detail.remark }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    let id = this.$route.query.id;
    let url = 'rongzixiangqing';
    // console.log(this.ajax_id(url,id).data);
    this.detail = this.ajax_id(url, id).data;
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 40px 0 40px 385px;
  width: 1475px;
  height: 536px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  display: flex;
  flex-flow: row wrap;
  align-content: space-between;
}

.root p {
  width: 1475px;
  height: 26px;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  line-height: 26px;
  color: #333333;
  letter-spacing: 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.root p span {
  display: inline-block;
  width: 130px;
  padding-right: 10px;
  color: #151515;
  text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
  /* 这行bai必加，兼容ie浏览器 */
}
</style>
